import { Box, Typography } from "@mui/material";

const Header = () => {
  return (
    <Box
      component="header"
      sx={{
        position: "relative",
        width: "100%",
        minHeight: { xs: 200, md: 320 },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        overflow: "hidden",
        background:
          "linear-gradient(180deg, #3b2a14 0%, #6b4c2a 40%, #b68a58 100%)",
      }}
    >
      {/* Placeholder background image — replace with your own */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          // backgroundImage: "url('/images/header-bg.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.35,
        }}
      />

      {/* Decorative overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(ellipse at center, transparent 40%, rgba(0,0,0,0.4) 100%)",
        }}
      />

      <Box sx={{ position: "relative", zIndex: 1, textAlign: "center", px: 2 }}>
        <Typography
          variant="h2"
          sx={{
            fontFamily: '"Cinzel", serif',
            color: "#f5e6c8",
            textShadow: "0 1px 2px rgba(0,0,0,0.6), 0 0 20px rgba(0,0,0,0.3)",
            fontWeight: 400,
            fontSize: { xs: "2rem", md: "3.5rem" },
            letterSpacing: 2,
          }}
        >
          Whispering Sand
        </Typography>
        <Typography
          variant="h6"
          sx={{
            fontFamily: '"Cinzel", serif',
            color: "#d4b483",
            mt: 1,
            fontSize: { xs: "0.9rem", md: "1.25rem" },
            letterSpacing: 4,
            textTransform: "uppercase",
          }}
        >
          Pharaoh Hound
        </Typography>
        <Typography
          variant="h6"
          sx={{
            fontFamily: '"Cinzel", serif',
            color: "#d4b483",
            fontSize: { xs: "0.9rem", md: "1.25rem" },
            letterSpacing: 4,
            textTransform: "uppercase",
          }}
        >
          Australian Shepherd Kennel
        </Typography>
      </Box>

      {/* Bottom decorative border */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          height: 4,
          background:
            "linear-gradient(90deg, transparent 0%, #d4b483 50%, transparent 100%)",
        }}
      />
    </Box>
  );
};

export default Header;
